import React, { Component } from 'react'
import './index.less'

export interface AppGridTabsPorps {
  tabs: string[];
  defaultTabIndex?: number;
  befChange?: () => boolean;
  onChange?: (index: number) => void;
}

export class AppGridTabs extends Component<AppGridTabsPorps> {
  state = { current: this.props.defaultTabIndex || 0 }

  hanldChange = (current: number) => {
    if (this.props.befChange && this.props.befChange()) {
      if (current !== this.state.current) {
        this.setState({ current })
        this.props.onChange && this.props.onChange(current)
      }
    }
  }

  renderItems = () => {
    let current = this.state.current;
    if (this.props.tabs && this.props.tabs.length > 0) {
      return (<React.Fragment>
        {this.props.tabs.map((tab: string, index: number) => {
          return (<div key={index}
            className={`app-grid-tab ${index === current ? 'active' : ''}`}
            onClick={e => this.hanldChange(index)}>
            {tab}
          </div>)
        })}
      </React.Fragment>)
    }

    return <React.Fragment />
  }

  render() {
    return (<div className="app-grid-tabs">
      {this.renderItems()}
    </div>)
  }
}








// WEBPACK FOOTER //
// ./src/qcc/AppGridTabs/index.tsx